import { SPLIT_API_KEY, USER_EMAIL_NAME } from '@/constants/env';
import { FeatureFlagController, SplitFeatureFlagProvider } from '@skand/feature-flags';
import Cookies from 'js-cookie';

// Make sure user key isn't undefined when user doesn't have the cookie
// Otherwise, it will return `control` treatment
const USER_EMAIL = (USER_EMAIL_NAME && Cookies.get(USER_EMAIL_NAME)) || 'user';

export const EXPLORE_RESPONSIVE = 'explore-responsive' as const;
export const WEBAPP_UI_IMPROVEMENTS = 'webapp-ui-improvements' as const;

const splitFeatureFlagProvider = SplitFeatureFlagProvider.createFromConfig({
  authorizationKey: SPLIT_API_KEY,
  key: USER_EMAIL,
});

export const featureFlagController = new FeatureFlagController<{
  'explore-responsive': 'on' | 'off';
  'webapp-ui-improvements': 'on' | 'off';
}>(splitFeatureFlagProvider);
